// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".char-width__wrapper[data-v-2b9019e8]{position:absolute;visibility:hidden;top:0;left:0}.char-width__wrapper .char-width__char[data-v-2b9019e8]{font-size:16px;line-height:16px;display:inline-block;white-space:pre}.char-width__wrapper .char-width__char--sm[data-v-2b9019e8]{font-size:14px}", ""]);
// Exports
module.exports = exports;
